import { jsx as _jsx } from "react/jsx-runtime";
import { SpinnerIcon } from '@icons';
import classNames from 'classnames';
import { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './spinner.module.scss';
const Spinner = ({ size = 'sm', speed = 'slow', }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const spinnerClass = useMemo(() => classNames(styles.spinner, styles[`spinner_${size}`], styles[`spinner_${speed}`], {
        [styles.dark]: isDarkMode,
    }), []);
    return (_jsx("span", { className: spinnerClass, style: { '--rc-spinner-speed': speed }, role: "img", children: _jsx(SpinnerIcon, {}) }));
};
Spinner.displayName = 'Spinner';
export { Spinner };
